<template>
  <div class="ds-myschedule-user">
    <div class="ds-myschedule-user-search">
      <el-input placeholder="请输入姓名" v-model="value">
        <i
          slot="suffix"
          class="el-input__icon el-icon-search"
          @click="openSelectUsers"
        ></i>
      </el-input>
    </div>
    <div class="ds-myschedule-user-list">
      <el-tree
        ref="tree"
        class="filter-tree"
        :data="userList"
        :props="defaultProps"
        :filter-node-method="filterNode"
        :default-checked-keys="defaultCheckedUserIds"
        node-key="id"
        default-expand-all
        show-checkbox
        @check-change="changeUser"
      >
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfMyscheduleUser",
  props: {
    userPath: {
      type: String,
      default: "",
    },
    userIds: {
      type: String,
      default: "",
    },
    myTreeNode: {
      type: Object,
      default: () => {
        return { label: "", id: "" };
      },
    },
  },
  computed: {},
  watch: {
    value(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      value: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      userList: [],
      defaultCheckedUserIds: [],
    };
  },
  created() {
    this.getUserList();
  },
  mounted() {},
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    openSelectUsers() {
      let that = this;
      let selectValue = [];
      let treeValue = this.$refs.tree.getCheckedKeys();
      if (treeValue?.length != 0) {
        let _treeValue = _.remove(treeValue, function (item) {
          return item != that.myTreeNode.id;
        });
        if (_treeValue?.length != 0) {
          _.each(_treeValue, (item) => {
            selectValue.push({
              text: that.userList.find((it) => {
                return it.id == item;
              })?.label,
              value: item,
            });
          });
        }
      }
      this.$openDialog({
        title: "选择人员",
        width: "80%",
        height: "500px",
        params: {
          path: this.$replace(this.userPath),
          selectValue: selectValue,
        },
        btns: [
          {
            text: "确定",
            handler(res) {
              if (res.content) {
                let vm = res.content;
                if (vm && vm.yes && dsf.isFunction(vm.yes)) {
                  let returnValue = vm.yes();
                  if (!returnValue) {
                    return false;
                  } else {
                    let userIds = [];
                    let userList = [that.myTreeNode];
                    let defaultCheckedUserIds = [that.myTreeNode.id];
                    if (returnValue?.length > 0) {
                      _.each(returnValue, (item) => {
                        userList.push({
                          label: item.text,
                          id: item._id,
                        });
                        userIds.push({
                          userId: item._id,
                          userName: item.text,
                        });
                        defaultCheckedUserIds.push(item._id);
                      });
                    }
                    let params = { userIds };
                    that.$http
                      .post("/agenda/follow/saveOrUpdate", params, {
                        headers: {
                          "Content-Type": "application/json",
                        },
                      })
                      .done(({ success, data, message }) => {
                        if (success) {
                          that.userList = userList;
                          that.defaultCheckedUserIds = defaultCheckedUserIds;
                          that.$emit("update:userIds", defaultCheckedUserIds.join(","));
                        } else {
                          dsf.layer.message(message, false);
                        }
                      })
                      .error((err) => {
                        dsf.layer.message(err.message || "请求异常", false);
                      });
                  }
                }
              }
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },

    getUserList() {
      this.$http
        .get("/agenda/follow/getFollowers")
        .done(({ success, data, message }) => {
          if (success) {
            let userList = [this.myTreeNode];
            let defaultCheckedUserIds = [this.myTreeNode.id];
            if (data.userIds?.length != 0) {
              _.each(data.userIds, (item) => {
                userList.push({
                  label: item.userName,
                  id: item.userId,
                });
                defaultCheckedUserIds.push(item.userId);
              });
            }
            this.defaultCheckedUserIds = defaultCheckedUserIds;
            this.userList = userList;
            this.$emit("update:userIds", defaultCheckedUserIds.join(","));
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    changeUser(data, checked, indeterminate) {
      let value = this.$refs.tree.getCheckedKeys();
      this.$emit("update:userIds", value.join(","));
    },
  },
};
</script>
